export default __webpack_public_path__ + "8250d22.png";